export const isBlackFriday = () => {
  const now = new Date();
  const month = now.getMonth() + 1;
  const year = now.getFullYear();
  return month === 11 && year === 2024;
};

export const formatDateToDateString = (date: Date): string => {
  const day = `0${date.getDate()}`.slice(-2);
  const month = `0${date.getMonth() + 1}`.slice(-2);
  const year = date.getFullYear();
  return [day, month, year].join('/');
};

export const formatDateToMonthDateString = (date: Date): string => {
  const day = date.getDate();
  const monthInt = date.getMonth();
  const month = [
    'Januray',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ][monthInt];
  const year = date.getFullYear();
  return [day, month, year].join(' ');
};
